import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/surat-rujukan-balik-haji";

async function create(data) {
  return http.postData(BASE, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

async function update(id, data) {
  return http.putData(`${BASE}/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

async function getByRegister(registerId: string | number) {
  return http.getData(`/register/${registerId}/surat-rujukan-balik-haji`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

async function find(id: number) {
  return http.getData(`${BASE}/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

async function sign(id, data) {
  return http.putData(`${BASE}/${id}/signature`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

async function destroy(id: number) {
  return http.deleteData(`${BASE}/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

function print(id) {
  window.open(`${http.getAPI()}${BASE}/${id}/pdf`, "_blank");
}

export default { create, update, getByRegister, find, sign, destroy, print };
